export var SubDomain;
(function (SubDomain) {
    SubDomain["PLAYER_SERVICES"] = "player-services";
})(SubDomain || (SubDomain = {}));
